// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"43":"366910de","232":"e5456988","348":"cf44d71d","391":"f37a44fd","489":"f3b6f17e","496":"4121fd96","516":"0a54549f","667":"f0d22891","826":"319dd62c","872":"f98588d6"}[chunkId] + ".chunk.js";
};